import { JobsBoardSection } from './JobsBoardSection';

export const JobsBoardView = () => {
  return <JobsBoardSection />;
};
